import Vue from 'vue'
import router from './router'
import plugins from './plugins'
import { loadClientId } from './business/http/client-id'
import { loadChannel } from './business/http/channel'
import App from './App.vue'

plugins(Vue)

import(/* webpackChunkName: "main-css" */ './assets/scss/main.scss') // eslint-disable-line

Vue.config.productionTip = process.env.NODE_ENV !== 'production'

new Vue({
  router,
  async created () {
    document
      .body.classList.remove('waiting')

    this.$http.setClientId(
      await loadClientId()
    )

    this.$http.setChannel(
      await loadChannel()
    )
  },
  render: h => h(App)
}).$mount('#app')
